import { ExamCenterMemberStatus } from '@exam-center/exam-center-member-details';
import { dayjs } from '@shared/utils';

import { type ExamCenterMember } from '../../types';

function mapStatus(status: string, invitationExpireAt: string | null) {
  if (status === 'INVITATION_PENDING' && dayjs(invitationExpireAt).isBefore(dayjs())) {
    return ExamCenterMemberStatus.INVITATION_EXPIRED;
  }
  return status as ExamCenterMemberStatus;
}

export function mapExamCenterMemberData(examCenterMember: ExamCenterMember, index: number) {
  const { id, user } = examCenterMember;

  if (!user) {
    throw new Error('User is required');
  } else if (!user.status) {
    throw new Error('User Status is required');
  }

  return {
    id: id,
    order: index,
    fullName: `${user.firstname} ${user.lastname}`,
    email: user.email,
    lastLoginAt: user.lastLoginAt,
    status: mapStatus(user.status, user.invitationExpireAt),
    roles: user.appRoles,
    userId: user.id,
  };
}
